module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Figures#fm-1"
    }
  }, [_c('em', [_vm._v("List of Figures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Foreword#fm-2"
    }
  }, [_c('em', [_vm._v("Foreword by John M. G. Barclay")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Preface#fm-3"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Abbreviation#fm-4"
    }
  }, [_c('em', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#fm-5"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "toc"
  }, [_vm._v("1.|")]), _vm._v(" The Classical Subtext-Hypothesis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-3"
    }
  }, [_vm._v("The Wright-Barclay Debate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-4"
    }
  }, [_vm._v("On the Alleged Safety of Public Criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("2.|")]), _vm._v(" "), _c('strong', [_vm._v("Beyond Hidden Criticism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reviving Hidden Criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Hidden to Unexpressed Criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Hidden to Merely Overlooked Criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("3.|")]), _vm._v(" "), _c('strong', [_vm._v("Rediscovering Contemporary Contexts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding—and Ignoring—Rome in a Pauline Passage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evoking Rome and the Emperor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Claudius’s Triumphal Procession from 44 CE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("4.|")]), _vm._v(" "), _c('strong', [_vm._v("Reconstructing Unease")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Claudius’s Triumph as an Opportunity for Glory and Scorn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Captives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Space and Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Triumphator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transcripts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("5.|")]), _vm._v(" "), _c('strong', [_vm._v("Sharpening Our Exegetical Senses")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exegetical Blind Spots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Misled Focus on “Code”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lack of Postcolonial Sensitivities and Romans 13:1–7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Methodology and Cognitive Linguistics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digital Humanities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Conclusion#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Bibliography#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60dfd2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0